function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 2c2.213 0 4 1.887 4 4.225 0 2.338-1.787 4.226-4 4.226S8 8.563 8 6.225 9.787 2 12 2zm0 20c-3.333 0-6.28-1.803-8-4.535.04-2.803 5.333-4.338 8-4.338 2.653 0 7.96 1.535 8 4.338C18.28 20.197 15.333 22 12 22z",
  fill: "#1976D2"
});

function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
}

export default SvgProfile;